import { CommonModule } from '@angular/common';
import { AfterViewInit, ChangeDetectionStrategy, Component, Input, ViewChild, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Clipboard } from '@angular/cdk/clipboard';
import { Device } from '@capacitor/device';
import { AuthService } from 'src/app/core/services/auth.service';
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { EventService } from 'src/app/core/services/event.service';
import { GuestService } from 'src/app/core/services/guest.service';
import { AnalyticsService } from 'src/app/core/services/analytics.service';
import QRCode from 'qrcode';
import { phoneOrEmailValidator } from '../create-event/qr-invite/qr-invite.component';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { InvitationCardDesignerComponent } from '../invitation-card-designer/invitation-card-designer.component';
import { InviteCardComponent } from '../invite-card/invite-card.component';
import { InviteCardExportService } from 'src/app/core/services/invite-card-export.service';
import { QrRenderService } from 'src/app/core/services/qr-render.service';
import { WhatsappUploadService } from 'src/app/core/services/whatsapp-upload.service';
import { CanvaTemplate, CANVA_TEMPLATES } from '../core/data/canva-templates';
import { inviteLinkFor } from '../core/utils/invite-link';

/** A small, category-spanning sample — the full list lives behind "See all templates". */
const CARD_TEMPLATE_IDS = ['wedding-1', 'wedding-3', 'birthday-1', 'DAHFDTzAq4k', 'DAG-SGor8SU'];

@Component({
    selector: 'app-invite-dialog',
    templateUrl: './invite-dialog.component.html',
    styleUrls: ['./invite-dialog.component.css'],
    encapsulation: ViewEncapsulation.Emulated
})
export class InviteDialogComponent implements AfterViewInit {
    isAddContactPopupOpen: boolean = false;
    qrImage!: any;
    inviteLink!: any;
    link!: string;
    platform: any;
    panelOpenState = false;
    contactForm!: FormGroup;
    contacts: any[] = []; // Store contacts
    temp_contacts: any[] = [];
    event_id: any;
    user_id: any;
    form!: FormGroup;
    isLoading: boolean = false;
    // Variable to track if editing
    editIndex: number | null = null;
    savedContacts: any;
    viewerLink: any;
    viewer_qrImage: any;
    // Define the columns to be displayed in the table
    displayedColumns: string[] = ['name', 'phone_number', 'email_address', 'actions'];
    event_name: string | null;
    filteredContacts: any[] = [];
    showAddContactForm = false;
    searchQuery: any;
    // web QR Code & Deep Links
    web_qrImage: any; // Replace with actual QR Code URL
    webLink: any;
    myPhotos_viewerUrl: any;
    myPhotos_collabUrl: any;
    qrCodeData: any;
    viewer_web_qrImage: any;
    viewerWebLink: any;
    role: string = 'Collaborator';
    allowGuestUploads: any;
    viewerSetting: any;
    albumType: any;
    linkType: any;
    selectedQrCode: string = '';
    /**
     * Hidden here regardless of environment.features.cardDesigner — this
     * dialog isn't the right place for it yet. invite-share still reads the
     * flag directly, so the two can be re-synced later just by switching
     * this back to `environment.features.cardDesigner`.
     */
    readonly cardDesignerEnabled = false;
    readonly cardTemplates: CanvaTemplate[] =
        CANVA_TEMPLATES.filter(t => CARD_TEMPLATE_IDS.includes(t.id));
    @ViewChild(InviteCardComponent) private inviteCard?: InviteCardComponent;
    /** The card rendered as a PNG, re-prepared whenever the QR on it changes. */
    private cardFile: File | null = null;
    private cardKey = '';

    /** Analytics: how long the dialog was open, and whether anything left it. */
    private openedAt = Date.now();
    private invitesSent = 0;
    private closeTracked = false;

    inviteCode: string | null;
    myphotos_viewer_qrCode: any;
    myphotos_collab_qrCode: any;
    hideMobile: boolean = false;
    eventStatus: any;
    urlPrefix: string = '/splash/';

    /** Empty until the event code comes back, or forever if the feature is off. */
    whatsappUploadUrl = '';
    /** "Sep 18, 3:45 PM" — shown next to the link so the host knows when to regenerate it. */
    whatsappUploadValidityLabel = '';
    whatsappCopied = false;

    constructor(private router: Router, private dialogRef: MatDialogRef<InviteDialogComponent>,
        private route: ActivatedRoute, private clipboard: Clipboard
        , private authService: AuthService, private eventService: EventService, private guestService: GuestService, private fb: FormBuilder, private http: HttpClient, public dialog: MatDialog
        , private analytics: AnalyticsService, private cardExport: InviteCardExportService, private qrRender: QrRenderService
        , private whatsappUpload: WhatsappUploadService) {
        this.contactForm = this.fb.group({
            name: ['', Validators.required],
            phone_number: ['', [Validators.pattern('^\\+?[1-9]\\d{1,14}$')]], // Simple phone number validation
            email_address: ['', [Validators.email]]
        }, {
            validators: phoneOrEmailValidator()  // Apply the custom validator
        });
        this.event_id = localStorage.getItem('e');
        this.user_id = localStorage.getItem('u');
        this.qrImage = localStorage.getItem('qrImage');
        this.event_name = localStorage.getItem('name');
        this.viewer_qrImage = localStorage.getItem('viewer_qrImage');
        this.viewerLink = inviteLinkFor(localStorage.getItem('viewer_hash'));
        this.inviteCode = localStorage.getItem('event_hash');

    }

    async ngOnInit() {
        // Fired before the rest of ngOnInit and deliberately not awaited: the
        // dialog's links must not wait on a token, and the eventStatus read
        // further down has been seen to throw on a missing key, which would
        // otherwise take this call down with it.
        this.loadWhatsappUpload();
        //  this.isLoading = true;
        const currentUrl = window.location.origin;
        // console.log('Current URL:', currentUrl); //__CONSOLE_LOG__
        let inviteCode: any;

        this.inviteLink = inviteLinkFor(this.inviteCode);
        this.webLink = currentUrl + "/splash/" + this.inviteCode;
        //    const res: any = await this.eventService.getUserContacts(this.event_id).toPromise();
        //   console.log({ res });
        // (this.eventService.getUserContacts(this.event_id)).subscribe({
        //     next: (res: any) => {
        //          this.isLoading = false;
       
        //         if (res) {
        //             this.savedContacts = res?.result.contacts;
        //             this.filteredContacts = this.savedContacts;
        //             this.contacts = res?.result.eventContacts;
        //             this.temp_contacts = [...this.contacts];
        //             //   localStorage.setItem('event_hash', res.result.event_hash);
        //             inviteCode = res?.result.event_hash;


        //             this.eventStatus = res?.result.event_status;
        //         }
        //     }
        // });
        // let isScheduled = localStorage.getItem('isScheduled')?.toString();
        // console.log('isScheduled:', isScheduled);

        // if (isScheduled === 'true') {
        //     this.eventStatus = 'scheduled';
        // } 
        this.eventStatus = localStorage.getItem('eventStatus');
        // console.log('Event Status:', this.eventStatus); //__CONSOLE_LOG__ //__CONSOLE_LOG__ //__CONSOLE_LOG__
        if (this.eventStatus.toLowerCase() === 'live') {
            this.urlPrefix = '/#/live/';
        }
        else if (this.eventStatus.toLowerCase() === 'scheduled') {
            this.urlPrefix = '/#/open-invite/';
        }
        else {
            this.urlPrefix = '/#/splash/';
        }
        // console.log('URL Prefix:', this.urlPrefix); //__CONSOLE_LOG__ //__CONSOLE_LOG__ //__CONSOLE_LOG__
        this.inviteLink = inviteLinkFor(localStorage.getItem('event_hash'));
        this.webLink = inviteLinkFor(localStorage.getItem('event_hash'));

        const payload = { restricted: true };
        const encoded = btoa(JSON.stringify(payload));
        //currentUrl + this.urlPrefix + localStorage.getItem('event_hash');
        this.myPhotos_viewerUrl = currentUrl + this.urlPrefix + localStorage.getItem('viewer_hash') + "?a=" + encoded;
        this.myPhotos_collabUrl = currentUrl + this.urlPrefix + localStorage.getItem('event_hash') + "?a=" + encoded;
        this.viewerWebLink = inviteLinkFor(localStorage.getItem('viewer_hash'));
        //currentUrl + this.urlPrefix + localStorage.getItem('eventId');

        // this.webLink = "https://events.picaggo.com/splash/"+inviteCode;
        this.web_qrImage = localStorage.getItem('web_qrImage');// Replace with actual QR Code URL

        this.viewer_web_qrImage = localStorage.getItem('web_viewer_qrImage');
        this.myphotos_viewer_qrCode = localStorage.getItem('myphotos_viewer_qrCode');
        this.myphotos_collab_qrCode = localStorage.getItem('myphotos_collab_qrCode');
        this.qrCodeData = {
            collab_Uploads_Web: this.web_qrImage,       // guest uploads = true, web
            collab_Uploads_Mobile: this.qrImage,    // guest uploads = true, mobile
            viewer_Web: this.viewer_web_qrImage,          // guest uploads = false, web
            viewer_Mobile: this.viewer_qrImage,
            myphotos_viewer_qrCode: this.myphotos_viewer_qrCode,          // guest uploads = false, web
            myphotos_collab_qrCode: this.myphotos_collab_qrCode,       // guest uploads = false, mobile
        };
        //  this.url = currentUrl+"/splash/"+this.hex;
        //inviteCode = localStorage.getItem('event_hash');//params['inviteCode'];

        // Retrieve parameters from the URL

        // this.route.queryParams.subscribe(params => {
        //     // this.qrImage = params['qrImage'];
        //     let inviteCode = localStorage.getItem('event_hash');//params['inviteCode'];
        //     this.inviteLink = "https://i.picaggo.com/" + inviteCode;
        //     this.webLink = currentUrl + "/splash/" + inviteCode;
        //     // this.webLink = "https://events.picaggo.com/splash/"+inviteCode;
        //     this.web_qrImage = localStorage.getItem('web_qrImage');// Replace with actual QR Code URL

        //     this.viewerWebLink = currentUrl + "/splash/" + localStorage.getItem('eventId');
        //     this.viewer_web_qrImage = localStorage.getItem('web_viewer_qrImage');
        //     this.isLoading = false;
        //     this.qrCodeData = {
        //         collab_Uploads_Web: this.web_qrImage,       // guest uploads = true, web
        //         collab_Uploads_Mobile: this.qrImage,    // guest uploads = true, mobile
        //         viewer_Web: this.viewer_web_qrImage,          // guest uploads = false, web
        //         viewer_Mobile: this.viewer_qrImage,       // guest uploads = false, mobile
        //     };

        // });

        this.form = this.fb.group({
            allowGuestUploads: [true],
            linkType: ['web'],  // or 'mobile',
            albumType: ['all']
        });

        this.form.valueChanges.subscribe(() => this.updateQRCode());


        this.updateQRCode();

        // The denominator for everything else on this screen: without it a drop
        // in `invite_sent` can't be told apart from hosts simply not opening the
        // dialog. Fired after the form exists so `link_type` is real.
        this.analytics.capture('invite_dialog_opened', {
            surface: 'invite_dialog',
            link_type: this.inviteLinkType(),
            event_status: (this.eventStatus || '').toString().toLowerCase(),
            is_mobile: this.isMobile,
        });
    }



    /**
     * Mirrors the guest-uploads toggle. It already picks which QR is shown, so
     * it has to pick what the card says too — "Scan to add your photos" over a
     * view-only code is a promise the link does not keep.
     */
    /**
     * The link this card's code encodes. Must match what the server would
     * encode for the same mode — pwa-qr-scan-count keys on the URL, so a
     * different string here would quietly split the counts.
     */
    get cardQrUrl(): string {
        return this.canUpload ? this.webLink : this.viewerWebLink;
    }

    get canUpload(): boolean {
        return !!this.form?.get('allowGuestUploads')?.value;
    }

    ngAfterViewInit() {
        this.prepareCardImage();
    }

    ngOnChanges() {
        this.updateQRCode();
    }

    private cardFileName(): string {
        const name = (this.event_name || 'event').replace(/\s+/g, '-');
        return `${name}-invite.png`;
    }

    /**
     * Renders the card in the background so the share button has a file ready.
     *
     * navigator.share() needs transient activation, and a tap that spends a
     * second rasterising has already spent it by the time it asks for the
     * sheet. Keyed on what the card shows, so toggling guest uploads — which
     * swaps the QR and the wording — re-renders rather than sending the
     * previous version.
     */
    private prepareCardImage(): void {
        const key = `${this.selectedQrCode}|${this.canUpload}`;
        if (key === this.cardKey && this.cardFile) return;
        this.cardKey = key;
        this.cardFile = null;
        // One turn, so the card has painted the QR that was just assigned.
        setTimeout(async () => {
            const card = this.inviteCard;
            if (!card) return;
            await card.whenReady();
            // One more turn so the <img> has taken the new src before capture.
            await new Promise((r) => setTimeout(r, 0));
            const file = await this.cardExport.toFile(card.element, this.cardFileName());
            if (this.cardKey === key) this.cardFile = file;
        }, 0);
    }

    updateQRCode() {
        const uploads = this.form.get('allowGuestUploads')?.value;
        const linkType = 'web';//this.form.get('linkType')?.value;
        const albumType = this.form.get('albumType')?.value;
        if (uploads && linkType === 'web' && albumType === 'all') {
            this.selectedQrCode = this.qrCodeData.collab_Uploads_Web;
        }
        // else if (uploads && linkType === 'app') {
        //     this.selectedQrCode = this.qrCodeData.collab_Uploads_Mobile;
        // } 
        else if (!uploads && linkType === 'web' && albumType === 'all') {
            this.selectedQrCode = this.qrCodeData.viewer_Web;
        }
        // else if (!uploads && linkType === 'app') {
        //     this.selectedQrCode = this.qrCodeData.viewer_Mobile;

        // }
        else if (!uploads && linkType === 'web' && albumType === 'my-photos') {
            // console.log('my-photos selectedQrCode:', this.qrCodeData.myphotos_viewer_qrCode); //__CONSOLE_LOG__ //__CONSOLE_LOG__

            this.selectedQrCode = this.qrCodeData.myphotos_viewer_qrCode;
        } else if (uploads && linkType === 'web' && albumType === 'my-photos') {
            this.selectedQrCode = this.qrCodeData.myphotos_collab_qrCode;
        }

        // console.log(this.selectedQrCode); //__CONSOLE_LOG__
        this.prepareCardImage();
    }

    // call this after every change
    onSettingsChange() {
        const linkType = 'web';//this.form.get('linkType')?.value;
        const albumType = this.form.get('albumType')?.value;
        // The guest-uploads toggle decides whether an invite can grow the album
        // at all, so a host turning it off is the most consequential thing that
        // happens on this screen short of sharing. Nothing recorded it before.
        this.analytics.capture('invite_setting_changed', {
            surface: 'invite_dialog',
            setting: 'allow_guest_uploads',
            value: this.canUpload,
            link_type: this.inviteLinkType(),
        });
        if (albumType == 'my-photos') {
            this.hideMobile = true;
        }
        else {
            this.hideMobile = false;
        }
        this.updateQRCode();
    }

    openAddContactPopup() {
        if (this.searchQuery) {
            this.contactForm.patchValue({
                name: this.searchQuery // Replace with API response value
            });
        }
        this.isAddContactPopupOpen = true;
    }


    closeAddContactPopup() {
        this.editIndex = null;
        this.contactForm.reset();
        this.contacts = this.temp_contacts;
        this.isAddContactPopupOpen = false;
    }

    searchContacts(event: Event): void {
        const inputElement = event.target as HTMLInputElement;
        const searchValue = inputElement.value ? inputElement.value.toLowerCase() : '';

        this.filteredContacts = this.savedContacts.filter((contact: { name: string; phone_number: string | string[]; email_address: string; }) =>
            contact.name.toLowerCase().includes(searchValue) ||
            contact.phone_number?.includes(searchValue) ||
            contact.email_address?.toLowerCase().includes(searchValue)
        );
    }

    // Function to delete a contact from event
    async onDeleteContact(index: number, id: any): Promise<void> {
        this.isLoading = true;
        (await this.eventService.deleteContact(this.event_id, this.user_id, id)).subscribe({
            next: (res: any) => {
                this.isLoading = false;
                // console.log({ res }); //__CONSOLE_LOG__
                this.contacts.splice(index, 1);  // Remove the contact from the array
                this.temp_contacts = this.contacts;
            },
            error: (err: any) => {
                this.isLoading = false;

                // console.error(err); //__CONSOLE_LOG__
            }
        })



    }

    // Function to download QR Code image
    downloadImage(imageSrc: string, filename: string) {
        const link = document.createElement('a');
        link.href = imageSrc;
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }


    // Function to copy text to clipboard
    copyToClipboard(text: string) {
        navigator.clipboard.writeText(text).then(() => {
            alert('Link copied to clipboard!');
        }).catch(err => {
            // console.error('Error copying link: ', err); //__CONSOLE_LOG__
        });
    }

    //   // Copy Web Collaborator Link
    //   copyLink() {
    //     this.copyToClipboard(this.inviteLink);
    //   }

    // Copy Web Viewer Link
    copyViewerWebLink() {
        this.copyToClipboard(this.viewerWebLink);
    }

    copyWebLink() {
        this.copyToClipboard(this.webLink);
    }

    // Copy App Collaborator Link
    copyAppLink() {
        this.copyToClipboard(this.inviteLink);
    }

    // Copy App Viewer Link
    copyViewerAppLink() {
        this.copyToClipboard(this.viewerLink);
    }

    // Function to delete a contact
    async onDelete(index: number, id: any): Promise<void> {
        this.isLoading = true;

        (await this.eventService.deleteContact('null', this.user_id, id)).subscribe({
            next: (res: any) => {
                this.isLoading = false;

                // console.log({ res }); //__CONSOLE_LOG__
                this.savedContacts.splice(index, 1);  // Remove the contact from the array
            },
            error: (err: any) => {
                this.isLoading = false;

                // console.error(err); //__CONSOLE_LOG__
            }
        })

    }

    async shareAppLink() {
        const fileType = 'image/jpeg'; // Replace with the appropriate type, e.g., 'image/png'
        const fileName = this.event_name + '_app_collab_qr.jpg';
        let qrImage: string = localStorage.getItem('qrImage') ?? '';
        if (!qrImage) {
            // console.error('Base64 image string is empty'); //__CONSOLE_LOG__
            return;
        }
        try {
            // Sanitize Base64 string and remove the prefix if present
            const sanitizedBase64 = qrImage.replace(/^data:image\/[a-z]+;base64,/, '').trim();

            // Convert Base64 to Blob
            const blob = this.base64ToBlob(sanitizedBase64, fileType);

            // Create a link element to trigger download
            const link = document.createElement('a');
            const url = URL.createObjectURL(blob);
            const file = new File([blob], fileName.replace(/\s+/g, '-'), { type: blob.type });

            if (navigator.share) {
                navigator.share({
                    title: 'Event QR Code',
                    text: 'Scan to access the invite',
                    files: [file]
                }).catch(err => console.error('Share failed:', err));
            } else {
                // Fallback if share is not supported
                const link = document.createElement('a');
                link.href = URL.createObjectURL(file);
                link.download = fileName;
                link.click();
            }

            // Clean up the object URL
            URL.revokeObjectURL(url);
        } catch (error) {
            // console.error('Failed to share image:', error); //__CONSOLE_LOG__
        }

    }

    async shareAppViewerLink() {
        const fileType = 'image/jpeg'; // Replace with the appropriate type, e.g., 'image/png'
        const fileName = this.event_name + '_app_viewer_qr.jpg';
        let qrImage: string = localStorage.getItem('viewer_qrImage') ?? '';
        if (!qrImage) {
            // console.error('Base64 image string is empty'); //__CONSOLE_LOG__
            return;
        }
        try {
            // Sanitize Base64 string and remove the prefix if present
            const sanitizedBase64 = qrImage.replace(/^data:image\/[a-z]+;base64,/, '').trim();

            // Convert Base64 to Blob
            const blob = this.base64ToBlob(sanitizedBase64, fileType);

            // Create a link element to trigger download
            const link = document.createElement('a');
            const url = URL.createObjectURL(blob);
            const file = new File([blob], fileName.replace(/\s+/g, '-'), { type: blob.type });

            if (navigator.share) {
                navigator.share({
                    title: 'Event QR Code',
                    text: 'Scan to access the invite',
                    files: [file]
                }).catch(err => console.error('Share failed:', err));
            } else {
                // Fallback if share is not supported
                const link = document.createElement('a');
                link.href = URL.createObjectURL(file);
                link.download = fileName;
                link.click();
            }

            // Clean up the object URL
            URL.revokeObjectURL(url);
        } catch (error) {
            // console.error('Failed to share image:', error); //__CONSOLE_LOG__
        }

    }

    async shareWebLink() {
        const fileType = 'image/jpeg'; // Replace with the appropriate type, e.g., 'image/png'
        const fileName = this.event_name + '_web_collab_qr.jpg';
        let qrImage: string = localStorage.getItem('web_qrImage') ?? '';
        if (!qrImage) {
            // console.error('Base64 image string is empty'); //__CONSOLE_LOG__
            return;
        }
        try {
            // Sanitize Base64 string and remove the prefix if present
            const sanitizedBase64 = qrImage.replace(/^data:image\/[a-z]+;base64,/, '').trim();

            // Convert Base64 to Blob
            const blob = this.base64ToBlob(sanitizedBase64, fileType);

            // Create a link element to trigger download
            const link = document.createElement('a');
            const url = URL.createObjectURL(blob);
            const file = new File([blob], fileName.replace(/\s+/g, '-'), { type: blob.type });

            if (navigator.share) {
                navigator.share({
                    title: 'Event QR Code',
                    text: 'Scan to access the invite',
                    files: [file]
                }).catch(err => console.error('Share failed:', err));
            } else {
                // Fallback if share is not supported
                const link = document.createElement('a');
                link.href = URL.createObjectURL(file);
                link.download = fileName;
                link.click();
            }

            // Clean up the object URL
            URL.revokeObjectURL(url);
        } catch (error) {
            // console.error('Failed to share image:', error); //__CONSOLE_LOG__
        }

    }


    async shareWebViewerLink() {
        const fileType = 'image/jpeg'; // Replace with the appropriate type, e.g., 'image/png'
        const fileName = this.event_name + '_web_viewer_qr.jpg';
        let qrImage: string = localStorage.getItem('web_viewer_qrImage') ?? '';
        if (!qrImage) {
            // console.error('Base64 image string is empty'); //__CONSOLE_LOG__
            return;
        }
        try {
            // Sanitize Base64 string and remove the prefix if present
            const sanitizedBase64 = qrImage.replace(/^data:image\/[a-z]+;base64,/, '').trim();

            // Convert Base64 to Blob
            const blob = this.base64ToBlob(sanitizedBase64, fileType);

            // Create a link element to trigger download
            const link = document.createElement('a');
            const url = URL.createObjectURL(blob);
            const file = new File([blob], fileName.replace(/\s+/g, '-'), { type: blob.type });

            if (navigator.share) {
                navigator.share({
                    title: 'Event QR Code',
                    text: 'Scan to access the invite',
                    files: [file]
                }).catch(err => console.error('Share failed:', err));
            } else {
                // Fallback if share is not supported
                const link = document.createElement('a');
                link.href = URL.createObjectURL(file);
                link.download = fileName;
                link.click();
            }

            // Clean up the object URL
            URL.revokeObjectURL(url);
        } catch (error) {
            // console.error('Failed to share image:', error); //__CONSOLE_LOG__
        }

    }

    // Function to handle editing a contact
    onEditContact(index: number): void {
        this.isAddContactPopupOpen = true;
        this.editIndex = index;  // Save index of the contact being edited
        const contact = this.contacts[index];
        // console.log(contact); //__CONSOLE_LOG__

        // Fill the form with the selected contact's data
        this.contactForm.setValue({
            name: contact.name,
            phone_number: contact.phone_number,
            email_address: contact.email_address
        });
        this.contacts.splice(index, 1);
    }


    async saveContact(selectedContact: any) {
        this.isAddContactPopupOpen = false;
        this.isLoading = true;
        let contact_Id = 'null';
        // console.log(this.contactForm.value); //__CONSOLE_LOG__
        // console.log(selectedContact); //__CONSOLE_LOG__
        if (selectedContact != null) {
            contact_Id = selectedContact?.id;
        }

        if (this.contactForm.valid) {
            const contact = this.contactForm.value;

            // Simulate saving contact via API
            (await this.eventService.saveContact(this.event_id, this.user_id, contact.name, contact.phone_number, contact.email_address, contact_Id)).subscribe({
                next: (res: any) => {
                    // console.log({ res }); //__CONSOLE_LOG__

                    if (res) {
                        // Add contact to the local list
                        this.contacts = res.result.contacts;
                        // this.contacts.push(contact);

                        // Clear the form
                        this.contactForm.reset();

                        this.panelOpenState = false;
                    }

                    (this.eventService.getUserContacts(this.event_id)).subscribe({
                        next: (res: any) => {
                            // console.log({ res }); //__CONSOLE_LOG__
                            this.isLoading = false;
                            this.savedContacts = res.result.contacts;
                            this.filteredContacts = this.savedContacts;
                            this.contacts = res.result.eventContacts;
                        }

                    })
                },
                error: (err: any) => {
                    // console.error(err); //__CONSOLE_LOG__
                    this.isLoading = false;
                    this.isAddContactPopupOpen = false;
                }
            })
        }
    }


    onSelectPreviousContact(index: number): void {
        //  this.isLoading = true;

        const selectedContact = this.savedContacts[index];

        // Check if the contact already exists in the current list
        const contactExists = this.contacts.some(contact =>
            contact.name === selectedContact.name &&
            contact.phone_number === selectedContact.phone_number &&
            contact.email_address === selectedContact.email_address
        );

        // Add the selected contact to the current list if it doesn't exist already
        if (!contactExists) {
            this.contacts.push(selectedContact);
            this.contactForm.setValue({
                name: selectedContact.name,
                phone_number: selectedContact.phone_number,
                email_address: selectedContact.email_address
            });
            this.saveContact(selectedContact);
        } else {
            alert('This contact is already in the list.');
            this.isLoading = false;
            //  this.contacts.splice(index, 1);
        }
    }

    downloadAppImage(): void {
        const link = document.createElement('a');
        const fileType = 'image/jpeg'; // Replace with the appropriate type, e.g., 'image/png'
        const fileName = this.event_name + '_app_collab_qr.jpg';
        let qrImage: string = localStorage.getItem('qrImage') ?? '';
        if (!qrImage) {
            // console.error('Base64 image string is empty'); //__CONSOLE_LOG__
            return;
        }

        try {
            // Sanitize Base64 string and remove the prefix if present
            const sanitizedBase64 = qrImage.replace(/^data:image\/[a-z]+;base64,/, '').trim();

            // Convert Base64 to Blob
            const blob = this.base64ToBlob(sanitizedBase64, fileType);

            // Create a link element to trigger download
            const link = document.createElement('a');
            const url = URL.createObjectURL(blob);
            link.href = url;
            link.download = fileName;
            link.click();

            // Clean up the object URL
            URL.revokeObjectURL(url);
        } catch (error) {
            // console.error('Failed to download image:', error); //__CONSOLE_LOG__
        }
    }

    downloadViewerAppImage(): void {
        const link = document.createElement('a');
        const fileType = 'image/jpeg'; // Replace with the appropriate type, e.g., 'image/png'
        const fileName = this.event_name + '_app_viewer_qr.jpg';
        let qrImage: string = localStorage.getItem('viewer_qrImage') ?? '';
        if (!qrImage) {
            // console.error('Base64 image string is empty'); //__CONSOLE_LOG__
            return;
        }

        try {
            // Sanitize Base64 string and remove the prefix if present
            const sanitizedBase64 = qrImage.replace(/^data:image\/[a-z]+;base64,/, '').trim();

            // Convert Base64 to Blob
            const blob = this.base64ToBlob(sanitizedBase64, fileType);

            // Create a link element to trigger download
            const link = document.createElement('a');
            const url = URL.createObjectURL(blob);
            link.href = url;
            link.download = fileName;
            link.click();

            // Clean up the object URL
            URL.revokeObjectURL(url);
        } catch (error) {
            // console.error('Failed to download image:', error); //__CONSOLE_LOG__
        }


    }

    downloadWebImage(): void {
        const link = document.createElement('a');
        const fileType = 'image/jpeg'; // Replace with the appropriate type, e.g., 'image/png'
        const fileName = this.event_name + '_web_collab_qr.jpg';
        let qrImage: string = localStorage.getItem('web_qrImage') ?? '';
        if (!qrImage) {
            // console.error('Base64 image string is empty'); //__CONSOLE_LOG__
            return;
        }

        try {
            // Sanitize Base64 string and remove the prefix if present
            const sanitizedBase64 = qrImage.replace(/^data:image\/[a-z]+;base64,/, '').trim();

            // Convert Base64 to Blob
            const blob = this.base64ToBlob(sanitizedBase64, fileType);

            // Create a link element to trigger download
            const link = document.createElement('a');
            const url = URL.createObjectURL(blob);
            link.href = url;
            link.download = fileName;
            link.click();

            // Clean up the object URL
            URL.revokeObjectURL(url);
        } catch (error) {
            // console.error('Failed to download image:', error); //__CONSOLE_LOG__
        }
    }

    downloadWebImageMyPhotos(): void {
        const link = document.createElement('a');
        const fileType = 'image/jpeg'; // Replace with the appropriate type, e.g., 'image/png'
        const fileName = this.event_name + '_myphotos_collab_qr.jpg';
        let qrImage: string = localStorage.getItem('myphotos_collab_qrCode') ?? '';
        if (!qrImage) {
            // console.error('Base64 image string is empty'); //__CONSOLE_LOG__
            return;
        }

        try {
            // Sanitize Base64 string and remove the prefix if present
            const sanitizedBase64 = qrImage.replace(/^data:image\/[a-z]+;base64,/, '').trim();

            // Convert Base64 to Blob
            const blob = this.base64ToBlob(sanitizedBase64, fileType);

            // Create a link element to trigger download
            const link = document.createElement('a');
            const url = URL.createObjectURL(blob);
            link.href = url;
            link.download = fileName;
            link.click();

            // Clean up the object URL
            URL.revokeObjectURL(url);
        } catch (error) {
            // console.error('Failed to download image:', error); //__CONSOLE_LOG__
        }
    }

    downloadViewerImageMyPhotos(): void {
        const link = document.createElement('a');
        const fileType = 'image/jpeg'; // Replace with the appropriate type, e.g., 'image/png'
        const fileName = this.event_name + '_myphotos_collab_qr.jpg';
        let qrImage: string = localStorage.getItem('myphotos_viewer_qrCode') ?? '';
        //localStorage.getItem('myphotos_collab_qrImage') ?? '';
        if (!qrImage) {
            // console.error('Base64 image string is empty'); //__CONSOLE_LOG__
            return;
        }

        try {
            // Sanitize Base64 string and remove the prefix if present
            const sanitizedBase64 = qrImage.replace(/^data:image\/[a-z]+;base64,/, '').trim();

            // Convert Base64 to Blob
            const blob = this.base64ToBlob(sanitizedBase64, fileType);

            // Create a link element to trigger download
            const link = document.createElement('a');
            const url = URL.createObjectURL(blob);
            link.href = url;
            link.download = fileName;
            link.click();

            // Clean up the object URL
            URL.revokeObjectURL(url);
        } catch (error) {
            // console.error('Failed to download image:', error); //__CONSOLE_LOG__
        }
    }


    downloadWebViewerImage(): void {
        const link = document.createElement('a');
        const fileType = 'image/jpeg'; // Replace with the appropriate type, e.g., 'image/png'
        const fileName = this.event_name + '_web_viewer_qr.jpg';
        let qrImage: string = localStorage.getItem('web_viewer_qrImage') ?? '';
        if (!qrImage) {
            // console.error('Base64 image string is empty'); //__CONSOLE_LOG__
            return;
        }

        try {
            // Sanitize Base64 string and remove the prefix if present
            const sanitizedBase64 = qrImage.replace(/^data:image\/[a-z]+;base64,/, '').trim();

            // Convert Base64 to Blob
            const blob = this.base64ToBlob(sanitizedBase64, fileType);

            // Create a link element to trigger download
            const link = document.createElement('a');
            const url = URL.createObjectURL(blob);
            link.href = url;
            link.download = fileName;
            link.click();

            // Clean up the object URL
            URL.revokeObjectURL(url);
        } catch (error) {
            // console.error('Failed to download image:', error); //__CONSOLE_LOG__
        }


    }
    // Helper function to convert Base64 to Blob
    private base64ToBlob(base64: string, contentType: string): Blob {
        const byteCharacters = atob(base64);
        const byteArrays = [];

        for (let offset = 0; offset < byteCharacters.length; offset += 512) {
            const slice = byteCharacters.slice(offset, offset + 512);
            const byteNumbers = new Array(slice.length);

            for (let i = 0; i < slice.length; i++) {
                byteNumbers[i] = slice.charCodeAt(i);
            }

            const byteArray = new Uint8Array(byteNumbers);
            byteArrays.push(byteArray);
        }

        return new Blob(byteArrays, { type: contentType });
    }

    setRole(role: string) {
        this.role = role;
    }

    /**
     * Which link the host is currently sharing, derived from the form rather
     * than duplicated per branch.
     *  - collaborator = guests may upload; viewer = view only
     *  - _myphotos    = scoped to the guest's own photos rather than the album
     * `linkType` is pinned to 'web' in every dispatcher below; the app variants
     * are commented out, so this reports what actually ships.
     */
    private inviteLinkType(): string {
        const uploads = this.form.get('allowGuestUploads')?.value;
        const albumType = this.form.get('albumType')?.value;
        const audience = uploads ? 'collaborator' : 'viewer';
        const scope = albumType === 'my-photos' ? '_myphotos' : '';
        return `web_${audience}${scope}`;
    }

    /**
     * One event for every way an invite leaves this screen. `event_id` and
     * `role` are attached automatically from the registered event context, so
     * they are deliberately not passed here.
     */
    private trackInviteSent(
        method: 'copy' | 'share' | 'download',
        format: 'link' | 'qr' | 'card' | 'plain_qr',
        extra?: Record<string, any>,
    ): void {
        this.invitesSent++;
        this.analytics.capture('invite_sent', {
            method,
            format,
            link_type: this.inviteLinkType(),
            surface: 'invite_dialog',
            ...extra,
        });
    }

    /**
     * Closing is the only other way out of this dialog, so it carries the
     * abandonment signal: `invites_sent: 0` is a host who opened the invite
     * screen and shared nothing. Guarded because close() and goBack() are
     * separate buttons and a dialog must only report leaving once.
     */
    private trackDialogClosed(method: 'close_button' | 'back'): void {
        if (this.closeTracked) return;
        this.closeTracked = true;
        this.analytics.capture('invite_dialog_closed', {
            surface: 'invite_dialog',
            method,
            invites_sent: this.invitesSent,
            link_type: this.inviteLinkType(),
            duration_ms: Date.now() - this.openedAt,
        });
    }

    /**
     * The WhatsApp route for guests who would rather send photos than open a
     * link. Silent on failure — the row never appears and the invite is
     * otherwise unchanged.
     */
    private loadWhatsappUpload(): void {
        // Multi-use INVITE token, not the single-use quick-upload one — this
        // link rides along with an invite that may be opened by many
        // different guests over days.
        this.whatsappUpload.getInviteLink(this.event_id, this.event_name || '').then(link => {
            if (link) {
                this.whatsappUploadUrl = link.url;
                this.whatsappUploadValidityLabel = link.validityLabel || '';
            }
        });
    }

    /**
     * Only offered on an upload link. On a view-only invite it would contradict
     * the link beside it — telling guests to send photos to an album they have
     * just been told they cannot add to.
     */
    get showWhatsappUpload(): boolean {
        return !!this.whatsappUploadUrl && this.canUpload;
    }

    /** The line that rides along with the invite when a WhatsApp route exists. */
    private get whatsappUploadLine(): string {
        return this.showWhatsappUpload
            ? `\n\nPrefer WhatsApp? Send your photos here instead: ${this.whatsappUploadUrl}`
            : '';
    }

    copyWhatsappUpload() {
        if (!this.whatsappUploadUrl) return;
        this.clipboard.copy(this.whatsappUploadUrl);
        this.whatsappCopied = true;
        setTimeout(() => (this.whatsappCopied = false), 2000);
        this.trackInviteSent('copy', 'link', { link_type_detail: 'whatsapp_upload' });
    }

    /** `fallbackFrom` is set when Share routed here rather than the host pressing Copy Link. */
    copyLink(fallbackFrom?: 'share_unsupported') {
        this.trackInviteSent('copy', 'link', fallbackFrom ? { fallback_from: fallbackFrom } : undefined);
        // this.clipboard.copy(this.inviteLink);
        // console.log('Event Status:', this.eventStatus); //__CONSOLE_LOG__ //__CONSOLE_LOG__ //__CONSOLE_LOG__
        if (this.eventStatus.toLowerCase() === 'live') {
            this.urlPrefix = '#/live/';
        }
        else if (this.eventStatus.toLowerCase() === 'scheduled') {
            this.urlPrefix = '#/open-invite/';
        }
        else {
            this.urlPrefix = '#/splash/';
        }
        // console.log('URL Prefix:', this.urlPrefix); //__CONSOLE_LOG__ 
        const currentUrl = window.location.origin;
        this.webLink = inviteLinkFor(localStorage.getItem('event_hash'));
        //currentUrl + this.urlPrefix + localStorage.getItem('event_hash');
        const payload = { restricted: true };
        const encoded = btoa(JSON.stringify(payload));
        //currentUrl + this.urlPrefix + localStorage.getItem('event_hash');
        this.myPhotos_viewerUrl = currentUrl + this.urlPrefix + localStorage.getItem('viewer_hash') + "?a=" + encoded;
        this.myPhotos_collabUrl = currentUrl + this.urlPrefix + localStorage.getItem('event_hash') + "?a=" + encoded;
        this.viewerWebLink = inviteLinkFor(localStorage.getItem('viewer_hash'));
        //currentUrl + this.urlPrefix + localStorage.getItem('eventId');


        const uploads = this.form.get('allowGuestUploads')?.value;
        const linkType = 'web';//this.form.get('linkType')?.value;
        const albumType = this.form.get('albumType')?.value;
        if (uploads && linkType === 'web' && albumType === 'all') {
            this.selectedQrCode = this.qrCodeData.collab_Uploads_Web;
            this.clipboard.copy(this.webLink);
        }
        // else if (uploads && linkType === 'app') {
        //     this.selectedQrCode = this.qrCodeData.collab_Uploads_Mobile;
        //     this.clipboard.copy(this.inviteLink);
        // } 
        else if (!uploads && linkType === 'web' && albumType === 'all') {
            this.selectedQrCode = this.qrCodeData.viewer_Web;
            this.clipboard.copy(this.viewerWebLink);
        }
        // else if (!uploads && linkType === 'app') {
        //     this.selectedQrCode = this.qrCodeData.viewer_Mobile;
        //     this.clipboard.copy(this.viewerLink);
        // }
        else if (!uploads && linkType === 'web' && albumType === 'my-photos') {
            this.selectedQrCode = this.qrCodeData.myphotos_viewer_qrCode;
            this.clipboard.copy(this.myPhotos_viewerUrl);
        } else if (uploads && linkType === 'web' && albumType === 'my-photos') {
            this.selectedQrCode = this.qrCodeData.myphotos_collab_qrCode;
            this.clipboard.copy(this.myPhotos_collabUrl);
        }
        alert('Link Copied!');
    }

    async openUrl() {
        this.isLoading = true
        const eventId = localStorage.getItem('e');
        
        if (!eventId) {
            alert('We lost track of which album this is. Go back and open it again.');
            return;
        }

        (await this.eventService.generateAnonymousLink(eventId)).subscribe({
            next: (response: any) => {
                
                let result = JSON.parse(response.body);
                // console.log('Anonymous link response:', result); //__CONSOLE_LOG__
                if (result && result.anonymous_link) {
                    const currentUrl = window.location.origin;
                    const guestUrl = result.anonymous_link;
                 //  this.clipboard.copy(guestUrl); 
                 this.isLoading = false;
                   this.copyToClipboard(guestUrl);
                 //  alert('Guest link copied to clipboard!');
                    // Open the URL in a new tab
                   // window.open(guestUrl, '_blank');
                } else {
                    this.isLoading = false;
                    alert('Failed to generate guest link');
                }
            },
            error: (error: any) => {
                this.isLoading = false;
                // console.error('Error generating anonymous link:', error); //__CONSOLE_LOG__
                alert('An error occurred while generating the guest link');
            }
        });
    }

    downloadQR() {
        // The card is what the host is looking at, so it is what should land in
        // the guest's chat. The bare-QR chain below stays as the fallback for
        // when rasterising fails.
        if (this.cardFile) {
            this.trackInviteSent('download', 'card');
            this.cardExport.download(this.cardFile);
            return;
        }
        // Reached only when rasterising the card failed or hadn't finished — the
        // host pressed "Save card" and got a bare QR instead. Flagged so that
        // degradation is visible rather than looking like a QR download.
        this.trackInviteSent('download', 'qr', { card_ready: false });
        const uploads = this.form.get('allowGuestUploads')?.value;
        const linkType = 'web';//this.form.get('linkType')?.value;
        const albumType = this.form.get('albumType')?.value;

        if (uploads && linkType === 'web' && albumType === 'all') {
            this.selectedQrCode = this.qrCodeData.collab_Uploads_Web;
            this.downloadWebImage();
        }
        //  else if (uploads && linkType === 'app') {
        //     this.selectedQrCode = this.qrCodeData.collab_Uploads_Mobile;
        //     this.downloadAppImage();
        // }
        else if (!uploads && linkType === 'web' && albumType === 'all') {
            this.selectedQrCode = this.qrCodeData.viewer_Web;
            this.downloadWebViewerImage();
        }
        //  else if (!uploads && linkType === 'app') {
        //     this.selectedQrCode = this.qrCodeData.viewer_Mobile;
        //     this.downloadViewerAppImage();
        // }
        else if (!uploads && linkType === 'web' && albumType === 'my-photos') {
            // console.log('my-photos selectedQrCode:', this.qrCodeData.myphotos_viewer_qrCode); //__CONSOLE_LOG__ //__CONSOLE_LOG__

            this.selectedQrCode = this.qrCodeData.myphotos_viewer_qrCode;
            this.downloadWebImageMyPhotos();
        } else if (uploads && linkType === 'web' && albumType === 'my-photos') {
            this.selectedQrCode = this.qrCodeData.myphotos_collab_qrCode;
            this.downloadViewerImageMyPhotos();
        }
    }

    close() {
        this.trackDialogClosed('close_button');
        this.dialogRef.close();
    }

    goBack() {
        this.trackDialogClosed('back');
        this.router.navigate(['event-detail/true']);
    }

    get isMobile(): boolean {
        return window.innerWidth <= 768;
    }

    async shareInvite() {
        const url = this.cardQrUrl;
        if (!url) {
            // A dead Share button. The link is built from localStorage hashes,
            // so this is silent breakage worth seeing rather than a no-op.
            this.analytics.capture('invite_share_failed', {
                surface: 'invite_dialog',
                reason: 'missing_link',
                link_type: this.inviteLinkType(),
            });
            return;
        }
        const text = this.canUpload
            ? `You're invited to add your photos to ${this.event_name || 'our event'}`
            : `You're invited to see the photos from ${this.event_name || 'our event'}`;

        if (navigator.share) {
            try {
                // With a WhatsApp route, the album link goes inside the text
                // instead of `url`: Android WhatsApp tacks `url` on after the
                // text, which put the album link below the WhatsApp line and
                // made the WhatsApp link the one previewed. Without that line,
                // `url` stays the album link, what the OS previews.
                await navigator.share(this.showWhatsappUpload
                    ? { title: this.event_name || 'Event', text: `${text}\n${url}${this.whatsappUploadLine}` }
                    : { title: this.event_name || 'Event', text, url });
                this.trackInviteSent('share', 'link', { with_whatsapp_upload: this.showWhatsappUpload });
            } catch (err: any) {
                // Without this, a host who opened the OS share sheet and backed
                // out of it is indistinguishable from one who never pressed
                // Share — both simply produce no event.
                this.analytics.capture('invite_share_dismissed', {
                    surface: 'invite_dialog',
                    format: 'link',
                    link_type: this.inviteLinkType(),
                    reason: err?.name === 'AbortError' ? 'dismissed' : 'error',
                });
            }
            return;
        }
        // No Web Share API: the button quietly degrades to a copy. Marked so
        // those copies can be told apart from deliberate Copy Link presses.
        this.copyLink('share_unsupported');
    }

    /**
     * The code on its own, for a host dropping it into their own artwork.
     * Deliberately only offered here and not in the create sheet, which is a
     * first-run moment; someone building a Canva template is already in the
     * toolbox.
     */
    async downloadPlainQr() {
        const url = this.cardQrUrl;
        if (!url) return;
        const dataUrl = await this.qrRender.render(url, { size: 1024 });
        if (!dataUrl) {
            this.analytics.capture('invite_plain_qr_failed', {
                surface: 'invite_dialog',
                link_type: this.inviteLinkType(),
            });
            return;
        }
        const link = document.createElement('a');
        link.href = dataUrl;
        link.download = `${(this.event_name || 'event').replace(/\s+/g, '-')}-qr.png`;
        link.click();
        // Its own format, not 'qr' — this is the deliberate escape hatch, and
        // lumping it in with the card's failure fallback would hide both.
        this.trackInviteSent('download', 'plain_qr');
    }



    async gotoHome() {
        this.isLoading = true;
        localStorage.removeItem('eventId');
        localStorage.removeItem('qrImage');
        localStorage.removeItem('name');
        localStorage.removeItem('viewer_qrImage');
        localStorage.removeItem('isHost');
        localStorage.removeItem('isScheduled');
        //localStorage.removeItem('u');
        localStorage.removeItem('e');
        localStorage.removeItem('eventData');
        localStorage.removeItem('inviteData');
        this.router.navigate(['/home']);

    }

    async saveAndgotoHome() {
        this.isLoading = true;

        (await this.eventService.inviteUsers(this.event_id)).subscribe({
            next: (res: any) => {
                // console.log({ res }); //__CONSOLE_LOG__
                localStorage.removeItem('eventId');
                localStorage.removeItem('qrImage');
                localStorage.removeItem('name');
                localStorage.removeItem('viewer_qrImage');
                localStorage.removeItem('isHost');
                localStorage.removeItem('isScheduled');
                //localStorage.removeItem('u');
                localStorage.removeItem('e');
                localStorage.removeItem('eventData');
                localStorage.removeItem('inviteData');
                localStorage.removeItem('formData');
                localStorage.removeItem('coverImage');
                this.router.navigate(['/home']);
            },
            error: (err: any) => {
                this.isLoading = false;

                // console.error(err); //__CONSOLE_LOG__
            }
        })

    }

    /**
     * Opens the card designer, seeded with what this dialog already knows.
     * A contained panel, not the full-screen takeover this same component
     * uses elsewhere — see the matching `::ng-deep .card-designer-dialog`
     * block in this file's CSS.
     */
    openCardDesigner(): void {
        this.analytics.capture('invite_printed_card_action', { action: 'design_own_card', surface: 'invite_dialog' });
        const dialogRef = this.dialog.open(InvitationCardDesignerComponent, {
            width: '92vw',
            height: '85vh',
            maxWidth: '960px',
            maxHeight: '680px',
            panelClass: 'card-designer-dialog',
        });
        dialogRef.componentInstance.eventName = this.event_name || '';
        if (this.selectedQrCode) dialogRef.componentInstance.qrCodeImage = this.selectedQrCode;
    }

    openCanvaTemplate(template: CanvaTemplate): void {
        this.analytics.capture('invite_printed_card_action', {
            action: 'canva_template_open', template_id: template.id, surface: 'invite_dialog',
        });
        window.open(template.canvaUrl, '_blank', 'noopener,noreferrer');
    }

    /**
     * Leaves this dialog entirely for the routed template gallery — same
     * close-then-navigate shape as `close()`, plus its own analytics action
     * so "browse templates" isn't indistinguishable from any other close.
     */
    goBrowseTemplates(): void {
        this.analytics.capture('invite_printed_card_action', { action: 'browse_templates', surface: 'invite_dialog' });
        this.trackDialogClosed('close_button');
        this.dialogRef.close();
        this.router.navigate(['/invitation']);
    }

}
